(() => {
  function initLanguageSwitcher(container: HTMLElement) {
    const trigger = container.querySelector<HTMLButtonElement>(
      '[data-language-switcher-trigger]',
    );
    const menu = container.querySelector<HTMLElement>(
      '[data-language-switcher-menu]',
    );

    if (!trigger || !menu) return;

    const links = Array.from(menu.querySelectorAll<HTMLAnchorElement>('a[href]'));
    let isOpen = false;

    function setOpen(open: boolean) {
      isOpen = open;
      trigger.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-hidden', String(!open));
      menu.toggleAttribute('inert', !open);
      menu.classList.toggle('is-open', open);
    }

    function close(restoreFocus = false) {
      setOpen(false);
      if (restoreFocus) trigger.focus();
    }

    trigger.addEventListener('click', () => {
      setOpen(trigger.getAttribute('aria-expanded') !== 'true');
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      event.preventDefault();
      setOpen(true);
      const link =
        event.key === 'ArrowDown' ? links[0] : links[links.length - 1];
      link?.focus();
    });

    container.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !isOpen) return;

      event.preventDefault();
      event.stopPropagation();
      close(true);
    });

    menu.addEventListener('click', (event) => {
      const target = event.target;
      if (target instanceof Element && target.closest('a[href]')) close();
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (target instanceof Node && !container.contains(target)) close();
    });

    window.addEventListener('pageshow', () => close());
    setOpen(false);
  }

  function init() {
    document
      .querySelectorAll<HTMLElement>('[data-language-switcher]')
      .forEach(initLanguageSwitcher);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
